import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Base44 client for entities
class EntityClient {
  constructor(entityName) {
    this.entityName = entityName;
    this.baseUrl = `${API_URL}/${entityName.toLowerCase()}`;
  }

  async list(sort = '-created_date') {
    try {
      const response = await axios.get(this.baseUrl, {
        params: { sort }
      });
      return response.data;
    } catch (error) {
      console.error(`Error listing ${this.entityName}:`, error);
      return [];
    }
  }

  async create(data) {
    try {
      const response = await axios.post(this.baseUrl, data);
      return response.data;
    } catch (error) {
      console.error(`Error creating ${this.entityName}:`, error);
      throw error;
    }
  }

  async get(id) {
    try {
      const response = await axios.get(`${this.baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting ${this.entityName}:`, error);
      throw error;
    }
  }

  async update(id, data) {
    try {
      const response = await axios.put(`${this.baseUrl}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating ${this.entityName}:`, error);
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await axios.delete(`${this.baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting ${this.entityName}:`, error);
      throw error;
    }
  }
}

// Integration client for emails and other services
class IntegrationClient {
  async SendEmail({ to, from_name = 'AmsWeb', subject, body }) {
    try {
      const response = await axios.post(`${API_URL}/send-email`, {
        to,
        from_name,
        subject,
        body
      });
      return response.data;
    } catch (error) {
      console.error('Error sending email:', error);
      throw error;
    }
  }
}

// Export base44 client
export const base44 = {
  entities: {
    Article: new EntityClient('Article'),
    Contact: new EntityClient('Contact')
  },
  integrations: {
    Core: new IntegrationClient()
  }
};
